/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Diff_Last_ImportInputs */

const cs_ebr_diff_last_import = /** @type {(inputs: Ebr_Diff_Last_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poslední import`)
};

const en_ebr_diff_last_import = /** @type {(inputs: Ebr_Diff_Last_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last import`)
};

/**
* | output |
* | --- |
* | "Last import" |
*
* @param {Ebr_Diff_Last_ImportInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_diff_last_import = /** @type {((inputs?: Ebr_Diff_Last_ImportInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Diff_Last_ImportInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_diff_last_import(inputs)
	return cs_ebr_diff_last_import(inputs)
});